import { combineReducers } from '@reduxjs/toolkit';
import warningBarReducer from '../slices/WarningBar/index';
import stateReducer from '../slices/state/index';

export const reducers = combineReducers({
  warning: warningBarReducer,
  state: stateReducer,
});
